import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  /**
   * Set a cookie with optional expiration days
   * @param name Cookie name
   * @param value Cookie value
   * @param days Days until expiration (default 7 days)
   * @param secure Use secure flag (default true)
   * @param sameSite SameSite attribute (default 'Strict')
   */
  setCookie(
    name: string, 
    value: string, 
    days: number = 7, 
    secure: boolean = true,
    sameSite: 'Strict' | 'Lax' | 'None' = 'Strict'
  ): void {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    const secureFlag = secure ? 'Secure;' : '';
    const sameSiteFlag = `SameSite=${sameSite};`;
    const path = 'path=/;';
    
    document.cookie = `${name}=${value};${expires};${path}${secureFlag}${sameSiteFlag}`;
  }

  /**
   * Get a cookie value by name
   * @param name Cookie name
   * @returns Cookie value or null if not found
   */
  getCookie(name: string): string | null {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }

  /**
   * Delete a cookie by name
   * @param name Cookie name
   */
  deleteCookie(name: string): void {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }

  /**
   * Check if a cookie exists
   * @param name Cookie name
   * @returns Boolean indicating if cookie exists
   */
  hasCookie(name: string): boolean {
    return this.getCookie(name) !== null;
  }

  /**
   * Clear all cookies
   */
  clearAllCookies(): void {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;';
    }
  }
}
